module.exports = __webpack_public_path__ + "img/banner-1.ab9b0015.png";